import { FaqBlock } from "../../../types";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Link } from "react-router-dom";

interface FaqProps {
  block: FaqBlock;
}

export default function Faq({ block }: FaqProps) {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="mx-auto max-w-5xl px-4 md:px-6">
        <div className="mx-auto max-w-xl text-center mb-10">
          <h2 className="text-balance text-2xl font-bold md:text-3xl lg:text-4xl text-prime-950">
            {block.title || "Häufig gestellte Fragen"}
          </h2>
        </div>

        <div className="mx-auto max-w-xl">
          <Accordion
            type="single"
            collapsible
            className="bg-muted dark:bg-muted/50 w-full rounded-2xl p-1"
          >
            {block.faqs &&
              block.faqs.map((item, index) => (
                <div className="group" key={index}>
                  <AccordionItem
                    value={`item-${index}`}
                    className="data-[state=open]:bg-card dark:data-[state=open]:bg-muted peer rounded-xl border-none px-7 py-1 data-[state=open]:border-none data-[state=open]:shadow-sm"
                  >
                    <AccordionTrigger className="cursor-pointer text-base hover:no-underline text-left">
                      {item.question}
                    </AccordionTrigger>
                    <AccordionContent>
                      <p className="text-base text-gray-600">{item.answer}</p>
                    </AccordionContent>
                  </AccordionItem>
                  <hr className="mx-7 border-dashed group-last:hidden peer-data-[state=open]:opacity-0" />
                </div>
              ))}
          </Accordion>

          <p className="text-muted-foreground mt-6 px-8 text-center">
            Nicht gefunden, was Sie suchen? <br />
            <Link
              to="/unternehmen/kontakt"
              className="text-primary font-medium hover:underline"
            >
              Kontaktieren Sie gerne unser Team
            </Link>{" "}
            – wir helfen Ihnen persönlich weiter.
          </p>
        </div>
      </div>
    </section>
  );
}
